import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography, Container, Paper, FormHelperText } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import Footer from '../home/Footer';
import './Register.css';
import { ConfirmModel } from "@ontime/types";
import AuthService from '../services/AuthService';
import CustomFormAction from '../customComponents/CustomFormAction';
import CustomButton from '../customComponents/CustomButton';
import { useSelector } from 'react-redux';
import { selectAuth } from '../stateManagement/authSlice';

const confirmRegistrationSchema = z.object({
    emailAddress: z.string().email("Invalid email format"),
  confirmationCode: z.string().min(6, "Code must be at least 6 characters"),
});

const ConfirmRegistration: React.FC = () => {
    const { register, handleSubmit, formState: { errors }, watch, setValue } = useForm<ConfirmModel>({
        resolver: zodResolver(confirmRegistrationSchema),
        defaultValues: {
        }
    });

    const [loading, setLoading] = useState(false);

    const auth = useSelector(selectAuth)

    useEffect(() => {
        console.log(auth)
        if (auth && auth.email) {
            setValue("emailAddress", auth.email);
        }
        else {
            navigate('/register')
        }

    }, [auth]);

    useEffect(() => {
        if (!AuthService.isTokenExpired()) {
            navigate('/')
        }
        if (AuthService.isTokenExpired()) {
            AuthService.logout();
        }
    });

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const handleConfirm = async (data: ConfirmModel) => {

        setLoading(true);

        try {
            const response = await AuthService.confirm(data);

            console.log('response', response.success);

            if (response.success) {
                enqueueSnackbar('Confirmation successful! Please login.', { variant: 'success' });
                navigate('/login');
            }
        } catch (error) {
            let errorMessage = typeof error === 'string' ? error :'Confirmation failed. Please try again.' ;
            console.log('errrrrr', error)

            enqueueSnackbar(errorMessage, { variant: 'error' });

        } finally {
            setLoading(false);
        }
    };

    const resendCode = async (event: React.FormEvent) => {
        event.preventDefault();
        setLoading(true);

        try {
            const response = await AuthService.resendCode(auth.email ?? '');

            console.log('response', response.success);

            if (response.success) {
                enqueueSnackbar('Confirmation code resent successfully.', { variant: 'success' });
            }
        } catch (error) {
            let errorMessage = typeof error === 'string' ? error :'Resending Code failed. Please try again.' ;
            console.log('errrrrr', error)

            enqueueSnackbar(errorMessage, { variant: 'error' });

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="register-container">
            <Container component="main" maxWidth="xs">
                <Paper className="register-paper" elevation={3}>
                    <Box className="logo-box" >
                        <img onClick={() => navigate('/home')} style={{ cursor: 'pointer' }} src="logo.png" alt="Logo" className="register-logo" />
                    </Box>
                    <Typography component="h1" variant="h5" className="register-title">
                        Confirm Registration
                    </Typography>
                    <form onSubmit={handleSubmit(handleConfirm)} noValidate>

                        <Box mt={2}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Email"
                                InputLabelProps={{ shrink: true }}
                                {...register('emailAddress')}
                                error={!!errors.emailAddress}
                                helperText={errors.emailAddress?.message}
                                disabled
                            />
                        </Box>

                        <Box mt={2}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Confirmation Code"
                                InputLabelProps={{ shrink: true }}

                                {...register('confirmationCode')}
                                error={!!errors.confirmationCode}
                                helperText={errors.confirmationCode?.message}
                            />
                        </Box>


                        <CustomFormAction>
                            <CustomButton
                                lable={loading ? 'Confirming ...' : 'Confirm'}
                                type='submit'
                                disabled={loading}
                                infoContent={`Confirm by eamil`}
                                size='medium'
                            />
                            <CustomButton
                                lable={loading ? 'Resending Code ...' : 'Resend Code'}
                                type='button'
                                disabled={loading}
                                onClick={resendCode}
                                infoContent={`Resending Code`}
                                size='medium'
                            />
                        </CustomFormAction>

                        <Box mt={2} textAlign="center">
                            <Typography variant="body2">
                                Already have an account? <a href="/login" style={{ textDecoration: "none", color: "#1976d2" }}>Log in here</a>
                            </Typography>
                        </Box>
                    </form>

                </Paper>
            </Container>
            <Box sx={{ height: '65px' }} />
            <div className="footer-register-container" >
                <Footer />
            </div>
        </div>
    );
};

export default ConfirmRegistration;
